import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { select, Store } from "@ngrx/store";
import { IAppState } from "@edp-store/state/app.state";
import { requestsAndOperationsGetServices } from "@edp-store/selectors/requests-and-operations.selector";
import { getContract } from "@edp-store/selectors/contract.selectors";
import { Contract } from "@edp-components/edp-contract";
import { take } from "rxjs/operators";
import { RequestsAndOperationsEnum } from "@edp-enums/requests-and-operations.enum";
import { Service } from "@edp-models/service.model";
import { ShowContractSelection } from "@edp-store/actions/contract.actions";
import { NewRequestService } from "@edp-pages/requests-and-operations/services/new-request.service";
import { NewModalService } from "@edp-pages/requests-and-operations/services/new-modal.service";

@Component({
    selector: "request-service-list",
    templateUrl: "./request-service-list.component.html",
    styleUrls: ["./request-service-list.component.scss"]
})
export class RequestServiceListComponent implements OnInit {
    public serviceList: Service[] = [];
    public contract: Contract;
    public cardSelected: Service;
    public servicesEnum = RequestsAndOperationsEnum;

    @Output() selectedService = new EventEmitter<Service>();

    constructor(
        private store: Store<IAppState>,
        private newRequestService: NewRequestService,
        public newModalService: NewModalService
    ) { }

    ngOnInit(): void {

        this.newRequestService.getRequestAndService().subscribe(newRequestVals => {
            if (newRequestVals) {
                this.cardSelected = newRequestVals.selectedService;
                this.selectedService.emit(this.cardSelected);
            }
        });

        this.store.pipe(select(requestsAndOperationsGetServices)).subscribe(services => {
             this.serviceList = services;
             this.lookupServiceByParams(services);
        });

        this.store.pipe(
            select(getContract),
            take(1)
        ).subscribe(contract => {
            if (contract) {
                this.contract = contract;
                this.newRequestService.selectContract(contract);
            } else {
                this.store.dispatch(new ShowContractSelection());
            }
        });
    }

    public selectedCard(selectedCard: Service): void {
        this.cardSelected = selectedCard;
        this.selectedService.emit(selectedCard);
    }

    private lookupServiceByParams(services: Service[]) {
        const newModalData = this.newModalService.getPopupData();
        if (newModalData && newModalData.selectedService) {
            const selectedService = services.find(
                service => !!service.acronym && service.acronym.toUpperCase() === newModalData.selectedService.toUpperCase());
            if (selectedService) {
                this.selectedCard(selectedService);
            }
        }
    }
}
